import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path
                fill="#FAFAFC"
                fillRule="evenodd"
                d="M5 4a1 1 0 00-1 1v13.586l2.293-2.293A1 1 0 017 16h12a1 1 0 001-1V5a1 1 0 00-1-1H5zM2.879 2.879A3 3 0 015 2h14a3 3 0 013 3v10a3 3 0 01-3 3H7.414l-3.707 3.707A1 1 0 012 21V5a3 3 0 01.879-2.121z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#FAFAFC"
                d="M12.998 11.864H11.39l-.228-6.757h2.063l-.228 6.757zm-.804 1.058c.326 0 .587.096.784.288.2.192.301.437.301.736 0 .295-.1.538-.301.73-.197.192-.458.288-.784.288-.321 0-.582-.096-.783-.288a.977.977 0 01-.295-.73c0-.294.098-.538.295-.73.2-.196.462-.294.783-.294z"
            ></path>
        </svg>
    );
}

export default Icon;
